import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, TextField } from '@material-ui/core';
import { AccountingEnumDto } from '.generated/api';

interface AccountingSelectProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  required?: boolean;
}

const AccountingSelect: React.FC<AccountingSelectProps> = (props) => {
  const { t } = useTranslation(['translations']);

  return (
    <TextField
      variant="outlined"
      fullWidth
      select
      label={t('organization_page.contract.labels.accounting')}
      name="accounting"
      {...props}
    >
      {Object.values(AccountingEnumDto).map((accounting) => (
        <MenuItem key={accounting} value={accounting}>
          {t(
            `organization_page.contract.accounting_type.${accounting.toLowerCase()}`,
          )}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default AccountingSelect;
